import _ from 'lodash'

/**
 * Editor Library
 * Used for built-in / standard items
 * The user generated templates are dynamically loaded via library side bar
 */
export default {
  namespaced: true,
  state: {
    visible: false,
    itemList: []
  },
  getters: {
    // Find an item from the library
    getLibraryItemById: (state) => (id) => {
      return state.itemList.find(item => item.id == id)
    },
  },
  mutations: {
    // Clear the library list
    clearLibrary(state) {
      state.itemList = []
    },
    
    // Add item(s) to the library list
    addBuiltInLibraryItem(state, itemList) {
      if(_.isArray(itemList)) {
        itemList.forEach(item => {
          state.itemList.push(item)
        })
      } else {
        state.itemList.push(itemList)
      }
    }
  }
}
